import React, { useEffect, useRef } from 'react';

export default function CheckboxInput({ label, indeterminate, ...props }) {
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.indeterminate = Boolean(indeterminate);
        }
    }, [indeterminate]);

    return (
        <label className="input-checkbox__label tw-flex tw-items-center tw-gap-x-1.5">
            <input {...props} type="checkbox" className="input-checkbox" ref={ref} />
            {label}
        </label>
    );
}
